import { FilterState } from "@models/FilterState"
import React from "react"
import ColumnFilter from "./ColumnFilter"
import MultiColumnFilter from "./MultiColumnFilter"

interface ColumnFiltersProps {
  filters: FilterState
  setFilters: Function
  questionnaires: any[]
}

const ColumnFilters = (props: ColumnFiltersProps) => {
  let { filters, setFilters, questionnaires } = props

  let tripProtectionFields = [
    "accountEmail",
    "name",
    "status",
    "dateOfBirth",
    "enrollmentId",
    "insuranceCost",
    "bookingNumber",
    "tripProtectionPlan",
  ]
  let questionnaireFields = ["accountEmail", "name"]
  let flightManifestFields = ["accountEmail", "name", "dateOfBirth", "gender"]
  let emergencyContactsFields = ["accountEmail", "name", "emergencyContacts"]
  let signatureFields = ["accountEmail", "name", "documents"]

  const renderQuestionnaireColumnFilter = (questionnaire: { name: ""; id: "" }) => {
    let fieldName = `questionnaire_${questionnaire.id}`

    return <ColumnFilter filters={filters} setFilters={setFilters} field={fieldName} label={questionnaire.name} />
  }

  return (
    <div className="mt-9">
      <div className="flex flex-wrap items-baseline gap-2 mb-4">
        <h3 className="mr-auto">Select What to Export</h3>
        <div className="flex flex-wrap gap-2">
          <MultiColumnFilter
            filters={filters}
            setFilters={setFilters}
            fields={tripProtectionFields}
            label="Trip Protection"
          />
          <MultiColumnFilter
            filters={filters}
            setFilters={setFilters}
            fields={flightManifestFields}
            label="Flight Manifest"
          />
          <MultiColumnFilter
            filters={filters}
            setFilters={setFilters}
            fields={emergencyContactsFields}
            label="Emergency Contacts"
          />
          <MultiColumnFilter filters={filters} setFilters={setFilters} fields={signatureFields} label="Signatures" />
        </div>
      </div>

      <div className="grid md:grid-cols-4 lg:grid-cols-5 p-2 align-top sm:p-8 sm:pt-4 bg-gray-100 border-gray-200">
        <div className="sm:col-span-4 md:col-span-5 font-semibold text-gray-800">Passenger Information</div>
        <ColumnFilter filters={filters} setFilters={setFilters} field="accountEmail" label="Email" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="name" label="Name" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="nickname" label="Nickname" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="phone" label="Phone" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="dateOfBirth" label="Date Of Birth" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="age" label="Age" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="gender" label="Gender" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="address" label="Address" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="added" label="Date Added" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="accountHolders" label="Account Holders" />
        <div className="sm:col-span-4 md:col-span-5  font-semibold text-gray-800 mt-4">Selections</div>
        <ColumnFilter filters={filters} setFilters={setFilters} field="packageName" label="Package Name" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="addons" label="Add-ons" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="addonSelectionDate" label="Add-on Selection Date" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="tripProtectionPlan" label="Trip Protection Plan" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="bookingNumber" label="Booking Number" />
        <div className="sm:col-span-4 md:col-span-5  font-semibold text-gray-800 mt-4">Other Information</div>
        <ColumnFilter filters={filters} setFilters={setFilters} field="listAssignments" label="List Assignments" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="listNotes" label="List Notes" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="documents" label="Documents" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="emergencyContacts" label="Emergency Contacts" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="partyNotes" label="Passenger Notes" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="accountNotes" label="Account Notes" />
        <div className="sm:col-span-4 md:col-span-5  font-semibold text-gray-800 mt-4">Questionnaires</div>
        {questionnaires.map((questionnaire) => renderQuestionnaireColumnFilter(questionnaire))}
        <div className="sm:col-span-4 md:col-span-5  font-semibold text-gray-800 mt-4">Traveler Status</div>
        <ColumnFilter filters={filters} setFilters={setFilters} field="status" label="Status" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="isCancelled" label="Cancelled?" />
        <ColumnFilter
          filters={filters}
          setFilters={setFilters}
          field="cancellationRequestDate"
          label="Cancel Request Date"
        />
        <ColumnFilter filters={filters} setFilters={setFilters} field="cancellationProcessedDate" label="Cancel Date" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="enrollmentId" label="Enrollment Id" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="onWaitlistSince" label="On Waitlist Since" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="confirmedAt" label="Confirmed At" />
        <div className="sm:col-span-4 md:col-span-5  font-semibold text-gray-800 mt-4">Payment Details</div>
        <ColumnFilter filters={filters} setFilters={setFilters} field="netPaid" label="Net Paid" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="remainingBalance" label="Remaining Balance" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="totalDue" label="Total Due" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="overdue" label="Overdue" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="isAutopayEnabled" label="Autopay Enabled" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="packageCost" label="Package Cost" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="addonsCost" label="Add-ons Cost" />
        <ColumnFilter filters={filters} setFilters={setFilters} field="insuranceCost" label="Trip Protection Cost" />
      </div>
    </div>
  )
}

export default ColumnFilters
